import { COLORS, TYPO } from "../../styles/uiConstants";

// ConfirmDialog + PromptDialog ortak kabuğu. Sade: renkli başlık/footer
// şeridi yok, kalınlık yalnızca başlık (600) ve ana aksiyonda (600).

export const dialogPaperSx = {
  borderRadius: 3,
  boxShadow: "0 16px 40px rgba(15,23,42,0.14)",
  overflow: "hidden",
};

export const dialogTitleSx = {
  fontWeight: 600,
  fontSize: TYPO.title,
  color: COLORS.slate800,
  px: 3,
  pt: 2.5,
  pb: 1,
};

export const dialogContentSx = {
  px: 3,
  pt: 0,
  pb: 2,
  "&.MuiDialogContent-root": { paddingTop: 0 },
};

export const dialogMessageSx = {
  color: COLORS.slate600,
  fontWeight: 400,
  fontSize: "0.875rem",
  lineHeight: 1.6,
};

export const dialogActionsSx = {
  gap: 1,
  px: 3,
  pt: 1,
  pb: 2.5,
};

export const dialogCancelButtonSx = {
  borderRadius: 2,
  fontWeight: 500,
  textTransform: "none",
  px: 2,
  borderColor: COLORS.slate300,
  color: COLORS.slate700,
  "&:hover": { borderColor: COLORS.slate400, bgcolor: COLORS.slate50 },
};

export const dialogConfirmButtonSx = (color) => ({
  borderRadius: 2,
  fontWeight: 600,
  textTransform: "none",
  px: 2,
  boxShadow: "none",
  background: color.bg,
  "&:hover": { background: color.hover, boxShadow: "none" },
});
